import request, { silentRequest } from '@/utils/request';
import QueryString from 'querystring'

// 普通上传文件
export function uploadFile(data) {
  return request.post('/activity/upload', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 300000
  })
}

// 数据字典
export function getDictList(type) {
  return request.get('/activity/dicts?type=' + type)
}
export function updateSchoolDict(data) {
  return request.post('/auth/dict/update', data)
}
export function getSchoolDictList() {
  return request.get('/auth/dict')
}

// 活动相关
export function createActivity(data) {
  return request.post('/activity/create', data)
}
export function updateActivity(data) {
  return request.post('/activity/update', data)
}
export function launchActivity(data) {
  return request.post('/activity/launch', data)
}
export function deleteActivity(id) {
  return request.post('/activity/delete/' + id)
}
export function getActivityListApi(data) {
  return request.get('/activity/list?' + QueryString.stringify(data))
}
export function getActDashboardListApi(data) {
  return request.get('/activity/dashboard-list?' + QueryString.stringify(data))
}
export function getActivityDetails(id) {
  return request.get('/activity/details?activity_id=' + id)
}
export function updateActivityStatus(activityId, status) {
  return request.post('/activity/status/update', { activity_id: activityId, activity_status: status })
}
export function getActivityWorksListApi(data) {
  return request.get('/activity/works?' + QueryString.stringify(data))
}
export function groupWorksApi(data) {
  return request.post('/activity/work/group', data)
}
export function getGroupingInfo(data) {
  return request.get('/activity/work/group/details?' + QueryString.stringify(data))
}
export function workDistributionApi(data) {
  return request.post('/activity/experts', data)
}
export function filterSecondWorksApi(data) {
  return request.post('/activity/filter/second_works', data)
}
export function getSecondWorksListApi(data) {
  return request.get('/activity/second_works/detail?' + QueryString.stringify(data))
}
export function filterFinalWinnersApi(data) {
  return request.post('/activity/filter/final_winners', data)
}
export function getFinalWinnersDetails(data) {
  return request.get('/activity/final_winners/detail?' + QueryString.stringify(data))
}

// 公告
export function searchAnnouncementApi(data) {
  return request.get('/announce/list?' + QueryString.stringify(data))
}
export function announceDashboadListApi(data) {
  return request.get('/announce/dashboard-list?' + QueryString.stringify(data))
}
export function getAnnouncementDetails(data) {
  return request.get('/announce/details?' + QueryString.stringify(data))
}
export function addAnnouncementApi(data) {
  return request.post('/announce/create', data)
}
export function editAnnouncementApi(data) {
  return request.post('/announce/update', data)
}
export function deleteAnnouncementApi(data) {
  return request.post('/announce/delete', data)
}

// 科创
export function createStigProject(data) {
  return request.post('/kechuang/create', data)
}
export function updateStigProject(data) {
  return request.post('/kechuang/update', data)
}
export function deleteStigProject(id) {
  return request.post('/kechuang/delete/' + id)
}
export function getStigProjectListApi(data) {
  return request.get('/kechuang/list?' + QueryString.stringify(data))
}
export function getStigDashboardListApi(data) {
  return request.get('/kechuang/dashboard-list?' + QueryString.stringify(data))
}
export function getStigProjectMembersApi(id) {
  return request.get('/kechuang/members?activity_id=' + id)
}
export function getStigProjectDetails(id) {
  return request.get('/kechuang/details?activity_id=' + id)
}
export function addActivityMembers(data) {
  return request.post('/kechuang/add-members', data)
}
export function deleteActivityMember(data) {
  return request.post('/kechuang/remove-members', data)
}
export function stuGroupApi(data){
  return request.post('/kechuang/members-groups',data)
}
export function getStigProjectWorksApi(data) {
  return request.get('/kechuang/works?' + QueryString.stringify(data))
}
export function getStigProjectWorkDetails(id) {
  return request.get('/kechuang/work/details?work_id=' + id)
}
export function submitDeadlineApi(data) {
  return request.post('/kechuang/count_work', data)
}
export function filterBestWorksApi(data) {
  return request.post('/kechuang/filter/best_work', data)
}
export function getBestWorkDetailsApi(data) {
  return request.get('/kechuang/work/list-by-status?' + QueryString.stringify(data))
}

// 用户
export function getUsersListApi(data) {
  return request.get('/auth/users?' + QueryString.stringify(data))
}
export function getAllUsersListApi(data) {
  return request.get('/auth/allUsers?' + QueryString.stringify(data))
}
export function deleteUserApi(id) {
  return request.post('/auth/users/delete' + id)
}
export function batchAddUsers(data) {
  return request.post('/auth/users/batch-create', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
export function getCoursesListApi(data) {
  return request.get('/course/courses?' + QueryString.stringify(data))
}

// 公共
export function getWorkDetails(id) {
  return request.get('/activity/work/details?work_id=' + id)
}
export function downloadAllFilesApi(data) {
  return silentRequest.get('/kechuang/work/download-multiple?' + QueryString.stringify(data), { responseType: 'blob' })
}
export function changePasswordApi(data) {
  return request.post('/auth/users/change-password', data)
}

// 学生
export function submitWork(data) {
  return request.post('/activity/work/submit-form', data)
}
export function getMyWorkList(data) {
  return request.get('/activity/work/my?' + QueryString.stringify(data))
}
export function getMyWorkDetails(id) {
  return request.get('/activity/work/my/details?work_id=' + id)
}
export function submitTopicApi(data) {
  return request.post('kechuang/work/submit-form', data)
}
export function getMyTopicList(data) {
  return request.get('/kechuang/work/my?' + QueryString.stringify(data))
}
export function getMyTopicDetails(id) {
  return request.get('/kechuang/work/my/details?work_id=' + id)
}
export function addReportLogApi(data) {
  return request.post('/kechuang/work/add-report', data)
}
export function getMyReportLogList(data) {
  return request.get('/kechuang/work/reports-list?' + QueryString.stringify(data))
}

// 评审
export function getReviewTaskList(data) {
  return request.get('/activity/review/task?' + QueryString.stringify(data))
}
export function getReviewWorkList(data) {
  return request.get('/activity/review/works?' + QueryString.stringify(data))
}
export function getReviewRecordsApi(data) {
  return request.get(`/activity/reviews?` + QueryString.stringify(data))
}
// ... existing code ...
export function getFilePreviewUrl(fileId) {
  const baseUrl = process.env.VUE_APP_BASE_URL || 'http://192.168.16.227:9007';
  return `${baseUrl}/activity/preview?file_id=${fileId}`;
}
export function downloadFileApi(id) {
  const baseUrl = process.env.VUE_APP_BASE_URL || 'http://192.168.16.227:9007';
  return `${baseUrl}/activity/download?file_id=${id}`;
}



// 联系我们相关接口
// 提交入驻申请	
export function submitApplicationApi(data) {
  return request.post('/contact/submit', data)
}
// 获取申请列表
export function getApplicationListApi(data) {
  return request.get('/contact/list?' + QueryString.stringify(data))
}
// 获取申请详情
export function getApplicationDetail(id) {
  return request.get('/contact/detail/' + id)
}
// 开通账号
export function approveApplicationApi(data) {
  return request.post('/contact/approve', data)
}
// 标记无效
export function rejectApplicationApi(data) {
  return request.post('/contact/reject', data)
}
// 删除记录
export function deleteApplicationApi(id) {
  return request.delete('/contact/delete/' + id)
} 


